module.exports = __webpack_public_path__ + "static/media/rating-2.5a130832.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rating-2.svg
// module id = 1091
// module chunks = 0